import moment from "moment";
import { EDIT_PARTNER_API, OPERATOR_GET_OPERATOR_API } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { fetchOperatorIdFailure, fetchOperatorIdSuccess } from "./reducer";

export const fetchOperatorbyId = (setLoading,operatorId,initialValues,operatorOptions,OperatorStatusOptions,setEditData, isPartner = false) => async (dispatch) => {
    try {
        setLoading(true)
        const url = isPartner ? `${EDIT_PARTNER_API}?id=${operatorId}` : `${OPERATOR_GET_OPERATOR_API}/${operatorId}`;
        const response = await determineBaseUrlAndPerformApiCall(url,'GET')
        const roleName = localStorage.getItem("roleName");
        setLoading(false)
        setEditData(response)
        dispatch(fetchOperatorIdSuccess(response))
        initialValues.businessName = response?.tradingName || response?.businessName || "",
        initialValues.Domain = operatorOptions?.find(optr => optr?.name === 'Domain')?.options?.find(option => option?.value === response?.domain);
        initialValues.state =  {value: response?.state, label: response?.state},
        initialValues.city =  {value: response?.city, label: response?.city},
        initialValues.zipCode =  response?.postcode || response?.zipcode || "",
        initialValues.endDate = moment(response?.existsDuring?.endDateTime).utc(),
        initialValues.Address = response?.street1 || response?.addressLine1 || "",
        initialValues.Address2 = response?.street2 || response?.addressLine2 || "",
        initialValues.country= {value: response?.country, label: response?.country}
        initialValues.firstname= response?.adminDetails?.profile?.firstName
        initialValues.lastname=response?.adminDetails?.profile?.lastName
        initialValues.username=response?.adminDetails?.userName
        initialValues.phone= response?.adminDetails?.dialCode || response?.primaryContact?.dialCode + response?.adminDetails?.phone || response?.primaryContact?.mobile
        initialValues.email= response?.adminDetails?.email
        initialValues.Status=  OperatorStatusOptions?.find(option => option?.value === response?.status)
        initialValues.isSSOUser = response?.adminDetails?.isSSOUser ;
        if(response?.domain === "SGCPowerUser" || response?.domain === "SGCExecutiveUser" || response?.domain === "SGCOperationsUser"){
            initialValues.Domain = operatorOptions?.find(optr => optr?.name === 'Domain')?.options?.find(option => option?.value === "SGCAdmin")
            initialValues.Role = operatorOptions?.find(optr => optr?.name === 'Role')?.options?.find(option => option?.value === response?.domain)
        }
        if(!response?.domain && roleName === "EVPartnerAdmin"){
            initialValues.Domain = operatorOptions?.find(optr => optr?.name === 'Domain')?.options?.find(option => option?.value === "operatorAdmin")
        }
        // initialValues.attributeList= response?.partyCharacteristic
    }
    catch (error) {
        setLoading(false)
        dispatch(fetchOperatorIdFailure(error.message))
    }
}